export default {
  // Page title
  'page.title': 'विश्व घड़ी',

  // Time zones and cities
  'timezone.utc': 'UTC',
  'timezone.local': 'स्थानीय समय',
  'timezone.currentTime': 'वर्तमान समय',
  'timezone.label': 'समय क्षेत्र',
  'timezone.title': '{{city}} समय क्षेत्र',
  'timezone.localClockOffset': 'स्थानीय घड़ी ऑफसेट',
  'timezone.timeZone': 'समय क्षेत्र',
  'timezone.today': 'आज',
  'timezone.hours': 'घं.',
  'timezone.standardTimeZone': 'मानक समय क्षेत्र',
  'timezone.daylightSavingTimeZone': 'डेलाइट सेविंग समय क्षेत्र',

  // City names (keeping English as standard)
  'city.newYork': 'New York',
  'city.london': 'London',
  'city.paris': 'Paris',
  'city.tokyo': 'Tokyo',
  'city.sydney': 'Sydney',
  'city.dubai': 'Dubai',
  'city.singapore': 'Singapore',
  'city.hongKong': 'Hong Kong',
  'city.shanghai': 'Shanghai',
  'city.beijing': 'Beijing',
  'city.mumbai': 'Mumbai',
  'city.moscow': 'Moscow',
  'city.berlin': 'Berlin',
  'city.losAngeles': 'Los Angeles',
  'city.chicago': 'Chicago',
  'city.toronto': 'Toronto',
  'city.vancouver': 'Vancouver',
  'city.brasilia': 'Brasília',
  'city.buenosAires': 'Buenos Aires',
  'city.cairo': 'Cairo',
  'city.istanbul': 'Istanbul',

  // How to use
  'howto.title': 'ऑनलाइन विश्व घड़ी का उपयोग कैसे करें',
  'howto.step1': 'यह विश्व घड़ी वेबसाइट दुनिया भर के किसी भी शहर के लिए वर्तमान समय और विश्व समय दिखाती है। दुनिया भर में तुरंत समय क्षेत्र, विश्व समय के अंतर और अंतर्राष्ट्रीय समय की जांच करें।',
  'howto.step2': 'विश्व घड़ी होमपेज आपका स्थानीय समय और प्रमुख शहरों के लिए कई विश्व घड़ियां प्रदर्शित करता है। प्रत्येक विश्व समय क्षेत्र सटीक समय, तारीख और समय क्षेत्र ऑफसेट जानकारी दिखाता है।',
  'howto.step3': 'विस्तृत समय क्षेत्र जानकारी देखने के लिए विश्व घड़ी सूची में किसी भी शहर के नाम पर क्लिक करें। प्रत्येक विश्व समय पृष्ठ उस स्थान के लिए व्यापक समय क्षेत्र डेटा और वर्तमान समय प्रदान करता है।',
  'howto.step4': 'किसी भी वैश्विक शहर में समय खोजने के लिए विश्व घड़ी खोज का उपयोग करें। विश्व समय क्षेत्र, अंतर्राष्ट्रीय समय समन्वय और वैश्विक समय प्रबंधन की आवश्यकताओं की जांच के लिए बिल्कुल सही।',

  // User reviews
  'reviews.title': 'उपयोगकर्ता समीक्षाएं',
  'reviews.globalBusiness': 'अंतर्राष्ट्रीय व्यापार के लिए आवश्यक! विभिन्न समय क्षेत्रों में बैठक के समय को आसानी से समन्वयित करें, बहुत सुविधाजनक।',
  'reviews.travelBlogger': 'यात्रा योजना के लिए आवश्यक! हमेशा अपने गंतव्य पर स्थानीय समय जानते हैं, अब और जेट लैग भ्रम नहीं।',
  'reviews.remoteTeam': 'दूरस्थ टीम सहयोग के लिए बिल्कुल सही! आसानी से देखें कि विभिन्न देशों में सहकर्मी कब काम कर रहे हैं।',
  'reviews.internationalFamily': 'विदेश में परिवार के साथ जुड़े रहने के लिए बढ़िया! हमेशा जानें कि उनकी नींद को परेशान किए बिना कॉल करने का सबसे अच्छा समय क्या है।',
  'reviews.managerZhang': 'एक परियोजना प्रबंधक के रूप में, यह मुझे वैश्विक ग्राहकों के साथ बैठकों को अधिक प्रभावी ढंग से निर्धारित करने में मदद करता है।',

  // User names
  'user.globalBusiness': 'ग्लोबल बिजनेस',
  'user.travelBlogger': 'ट्रैवल ब्लॉगर',
  'user.remoteTeam': 'रिमोट डेवलपर',
  'user.internationalFamily': 'इंटरनेशनल फैमिली',
  'user.managerZhang': 'प्रबंधक झांग',

  // Keywords
  'keywords.worldclock': 'world clock time zones international time what time is it',
  'keywords.chinese': '世界时钟 时区 国际时间 现在几点',
  'keywords.japanese': '世界時計 タイムゾーン 国際時間 今何時',
  'keywords.spanish': 'reloj mundial zonas horarias tiempo internacional qué hora',
  'keywords.german': 'Weltzeituhr Zeitzonen internationale Zeit wie spät',
  'keywords.french': 'horloge mondiale fuseaux horaires temps international quelle heure',
  'keywords.russian': 'мировые часы часовые пояса международное время который час',

  // Country related
  'countriesTime': 'देश के अनुसार समय',
  'timeIn': 'समय',
  'cities': 'शहर',
  'available': 'उपलब्ध',
  'citiesIn': 'शहर',
  'viewDetails': 'विवरण देखें',
  'countryNotFound': 'देश नहीं मिला',
  'backToWorldClock': 'विश्व घड़ी पर वापस जाएं',
  'cityNotFound': 'शहर नहीं मिला',
  'popularCitiesIn': 'में लोकप्रिय शहर',
  'currentTime': 'वर्तमान समय',
};
